import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CustomFieldTypeName } from "@air/api/types";
import classNames from "classnames";
import capitalize from "lodash/capitalize";
import { useMemo } from "react";
import { customFieldIconMap } from "~/constants/customFieldIconMap";
const fieldDescriptionMap = {
    [CustomFieldTypeName.singleSelect]: "Values can be arranged as columns in a Kanban board.\ne.g. “Status”",
    [CustomFieldTypeName.multiSelect]: "Useful when an item can have multiple values.\ne.g. “Social media platform”",
    [CustomFieldTypeName.date]: "For storing time-based info.\ne.g. “Expiration date”",
    [CustomFieldTypeName.plainText]: "Free text field for more descriptive metadata.\ne.g. “Credit notes”"
};
export const CustomFieldTypeSelectListItem = (param)=>{
    let { fieldTypeId, fieldTypes } = param;
    const fieldType = useMemo(()=>fieldTypes.find((ft)=>ft.id === fieldTypeId), [
        fieldTypeId,
        fieldTypes
    ]);
    if (!fieldType) return null;
    const Icon = customFieldIconMap[fieldType.title];
    return /*#__PURE__*/ _jsxs("div", {
        className: classNames("flex grow cursor-pointer items-center gap-3 rounded-4 p-1.5 hover:bg-grey-4"),
        children: [
            /*#__PURE__*/ _jsx(Icon, {
                className: "mt-1 size-4 shrink-0 self-start text-grey-10"
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "flex grow flex-col",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-14 font-medium text-grey-11",
                        children: capitalize(fieldType.title)
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-12 text-grey-10",
                        children: fieldDescriptionMap[fieldType.title]
                    })
                ]
            })
        ]
    });
};
